import { render } from "./DownloadModelPage.vue?vue&type=template&id=0704a176"
import script from "./DownloadModelPage.vue?vue&type=script&lang=js"
export * from "./DownloadModelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__